import React from "react";
import moment from "moment";
import { useEventContext } from "../../context/EventContext";
import { useLocaleContext } from "../../context/LocaleContext";
import Timeout from "../../components/Player/Overlay/Timeout";
import './style.scss';

const timeoutFormats = {
    DD_HH_MM_SS: "dd_hh_mm_ss",
    DD_HH_MM: "dd_hh_mm",
}

export default ({ block }) => {
    const $locale = useLocaleContext();
    const { event } = useEventContext();

    const className = "countdown-block";
    const timeStart = moment.unix(event?.timeStart);
    const emptyVisibleDay = block.emptyVisibleDay;
    const isVisibleSeconds = block.timeoutFormat === timeoutFormats.DD_HH_MM_SS;

    return (
        <section className={`page-block ${className}`}>
            <div className={`${className}-wrapper`}>
                {block.showTitle && <h1>{$locale.getProperty(block, 'title')}</h1>}
                <Timeout
                    time={timeStart}
                    emptyVisibleDay={emptyVisibleDay}
                    isVisibleSeconds={isVisibleSeconds}
                />
            </div>
        </section>
    );
}
